export const STORAGE_TYPES = {
  LOCAL: 'local',
  SESSION: 'session'
};


function getStorageType(storageType) {
  if (storageType === STORAGE_TYPES.LOCAL) {
    return localStorage;
  } else if (storageType === STORAGE_TYPES.SESSION) {
    return sessionStorage;
  } else {
    throw new Error("Invalid storage type. Use 'local' or 'session'.");
  }
}

export function setInStorage( key, value, storageType = STORAGE_TYPES.LOCAL) {
  try {
    const storage = getStorageType(storageType);
    storage.setItem(key, value);
  } catch (error) {
    console.error(`Error setting item in ${storageType}Storage`, error);
  }
}

export function getFromStorage(key, storageType = STORAGE_TYPES.LOCAL) {
  try {
    const storage = getStorageType(storageType);
    return storage.getItem(key);
  } catch (error) {
    console.error(`Error getting item from ${storageType}Storage`, error);
    return null;
  }
}

export function removeFromStorage(key ,storageType = STORAGE_TYPES.LOCAL) {
  try {
    const storage = getStorageType(storageType);
    storage.removeItem(key);
  } catch (error) {
    console.error(`Error removing item from ${storageType}Storage`, error);
  }
}
